import React from "react";
import { Modal, Nav, Tab } from "react-bootstrap";
import modelImg from "../../Assets/remove.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const ModalComponent = ({
  show,
  handleClose,
  productDetails,
  activeTab,
  modalClass,
  modalRootClass,
  RedemHeading,
  RedemContent,
}) => {
  const translation = getTranslationData();
  const renderInstructionHtmlContent = () => ({
    __html: productDetails?.productReducer?.instructionsContent,
  });

  const renderHowToUseHtmlContent = () => ({
    __html: productDetails?.productReducer?.howToUseContent,
  });

  const renderTermsConHtmlContent = () => ({
    __html: productDetails?.productReducer?.tncContent,
  });

  const renderRedemHtmlContent = () => ({
    __html: RedemContent || "",
  });

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="exampleModalLabel"
      centered
      className={modalRootClass}
      dialogClassName={`${modalClass}`}
    >
      <div
        className={`modal-header-custom justify-content-center p-1 ${modalClass}`}
      >
        <button
          type="button"
          className="modal-btn lineBreakModalHeader"
          aria-label="Close"
          onClick={handleClose}
        >
          <img className="Modalbottomsheetimg" src={modelImg} alt="Close" />
        </button>
      </div>

      <Modal.Body className="modal-body pt-0 modal-body-custom">
        {RedemHeading ? (
          <>
            <h5 className="redem-head text-center">{RedemHeading}</h5>
            <div
              className="list-bullet"
              style={{
                overflowWrap: "break-word",
              }}
              dangerouslySetInnerHTML={renderRedemHtmlContent()}
            />
          </>
        ) : activeTab === "terms" ? (
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab}>
            <Nav variant="tabs" className="custom-nav-terms mb-3">
              <Nav.Item>
                <Nav.Link eventKey="terms">
                  {translation?.terms_condition}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="list-pad">
              <Tab.Pane eventKey="terms">
                <div
                  className="list-bullet ul_list_listing"
                  style={{
                    overflowWrap: "break-word",
                  }}
                  dangerouslySetInnerHTML={renderTermsConHtmlContent()}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        ) : (
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeTab}>
            <Nav variant="tabs" className="custom-nav mb-3">
              <Nav.Item>
                <Nav.Link eventKey="instr" className="left-tab">
                  {translation?.importantInstructions}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="redeem" className="right-tab">
                  {translation?.how_to_use}
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="howToUse list-pad ul_list_listing">
              <Tab.Pane eventKey="instr">
                <div
                  className="tab-content-scroll"
                  style={{
                    overflowWrap: "break-word",
                  }}
                  dangerouslySetInnerHTML={renderInstructionHtmlContent()}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="redeem">
                <div
                  className="tab-content-scroll"
                  style={{
                    overflowWrap: "break-word",
                  }}
                  dangerouslySetInnerHTML={renderHowToUseHtmlContent()}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
